'use strict';

import { forEach } from 'lodash';

export default (API) => ({
    stats: {
        /**
         * @deprecated
         */
        getView: (
            dateStart,
            dateStop,
            establishments,
            places,
            resources,
            establishmentServiceTemplates,
            timezone = null,
            headOffices = null,
            modules = null,
            groupBy = null,
            view = null,
            gainValuesOverride = null
        ) => {
            let url = 'v3/statistics/view';
            url += '?dateStart=' + dateStart;
            url += '&dateStop=' + dateStop;
            url += establishments ? ('&establishments=' + establishments) : '';
            url += places ? ('&places=' + places) : '';
            url += resources ? ('&resources=' + resources) : '';
            url += establishmentServiceTemplates ? ('&establishmentServiceTemplates=' + establishmentServiceTemplates) : '';
            url += timezone ? '&timezone=' + timezone : '';
            url += headOffices ? '&headOffices=' + headOffices : '';
            url += modules ? '&modules=' + modules : '';
            url += view ? '&view=' + view : '';
            url += groupBy ? '&groupBy=' + groupBy : '';

            if (gainValuesOverride) {
                url += gainValuesOverride['bookingGainMinutes'] ? '&bookingGainMinutes=' + gainValuesOverride['bookingGainMinutes'] : '';
                url += gainValuesOverride['cancellationGainMinutes'] ? '&cancellationGainMinutes=' + gainValuesOverride['cancellationGainMinutes'] : '';
                url += gainValuesOverride['reminderGainMinutes'] ? '&reminderGainMinutes=' + gainValuesOverride['reminderGainMinutes'] : '';
                url += gainValuesOverride['relaunchGainMinutes'] ? '&relaunchGainMinutes=' + gainValuesOverride['relaunchGainMinutes'] : '';

                url += gainValuesOverride['bookingHourlyRate'] ? '&bookingHourlyRate=' + gainValuesOverride['bookingHourlyRate'] : '';
                url += gainValuesOverride['cancellationHourlyRate'] ? '&cancellationHourlyRate=' + gainValuesOverride['cancellationHourlyRate'] : '';
                url += gainValuesOverride['reminderHourlyRate'] ? '&reminderHourlyRate=' + gainValuesOverride['reminderHourlyRate'] : '';
                url += gainValuesOverride['relaunchHourlyRate'] ? '&relaunchHourlyRate=' + gainValuesOverride['relaunchHourlyRate'] : '';
            }

            const request = API.http.get(url);
            return API.handleError(request);
        },

        insertKPIStatisticForEstablishment: (establishment, service, place, firstAvailabilityDate, isGapFlag) => {
            const url = `v3/establishments/${establishment}/statistics/kpi`;

            const request = API.http.post(
                url,
                { place: place, service: service, firstAvailabilityDate: firstAvailabilityDate, isGapFlag: isGapFlag },
                { headers: { 'Content-Type': 'application/json' } }
            );
            return API.handleError(request);
        },

        incrementPublicVisitsForEstablishment: (establishment, isGapFlag) => {
            const url = `v3/establishments/${establishment}/statistics/publicVisits`;

            const request = API.http.post(
                url,
                { isGapFlag: isGapFlag },
                { headers: { 'Content-Type': 'application/json' } }
            );
            return API.handleError(request);
        },

        createStatisticsReportJob(payload) {
            let url = `v3/statistics/job`;
            const params = new FormData();
            forEach(payload, (val, key) => {
                params.append(key, val);
            });

            const request = API.http.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 30000 });
            return API.handleError(request);
        },

        getStatisticsReportJob: (jobId) => {
            const url = `/v3/statistics/job/${jobId}`;
            const request = API.http.get(url);
            return API.handleError(request);
        }
    }
});
